import { matchesWorkSuiteRoot, type RelatedApplication, supportsInstalledAppDetection } from "~/pwa/openApp";

type RelatedAppsNavigator = Navigator & {
	getInstalledRelatedApps?: () => Promise<RelatedApplication[]>;
};

const detectRootInstalled = async (): Promise<boolean> => {
	if (!supportsInstalledAppDetection()) return false;
	try {
		const related = await (navigator as RelatedAppsNavigator).getInstalledRelatedApps?.();
		return related ? matchesWorkSuiteRoot(related) : false;
	} catch {
		return false;
	}
};

export default detectRootInstalled;
